/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : 字典</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2019年08月02日</li>
 * <li>@author     : ____′↘夏悸</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
HeyUI.initDict({
	accountingStandards: {0: "小企业会计准则", 1: "企业会计准则"},
	defaultRadios: {1: "是", 0: "否"},
	statusRadios: {1: "正常", 0: "不可用"},
	enableRadios: {1: "启用", 0: "不启用"},
	needRadios: {1: "需要", 0: "不需要"},
	reportTemplateType: {0: "普通报表", 1: "资产报表"},
	reportTemplateItemType: {0: "资产", 1: "负债", 2: "所有者权益"},
	accessRules0: {0: " 净发生额", 1: "借方发生额", 2: "贷方发生额"},
	accessRules1: {3: "余额", 4: "借方余额", 5: "贷方余额"},
	operation: {'+': " +", '-': "-"},
	reportTemplateItemSources: {0: "表外公式", 1: "表内公式"},
	vatRadios: {0: "小规模纳税人", 1: "一般纳税人"},
	roles: {'Manager': "账套管理员", 'Director': "主管", 'Making': "制单人", 'Cashier': "出纳", 'View': "查看"},
	voucherTemplateType: {0: "日常支出", 1: "采购", 2: "销售", 3: "工资", 4: "税金", 5: "折旧和摊销"},
	industry: {"0": "IT·通信·电子·互联网", "1": "金融业", "2": "房地产·建筑业", "3": "商业服务", "4": "贸易·批发·零售·租赁业", "5": "文体教育·工艺美术", "6": "生产·加工·制造", "7": "交通·运输·物流·仓储", "8": "服务业", "9": "文化·传媒·娱乐·体育", "10": "能源·矿产·环保", "11": "政府·非盈利机构", "12": "农·林·牧·渔·其他"},
	// 账套模板：会计准则 + 增值税种类 组合（与后端 AccountSetsServiceImpl.ACCOUNT_TEMPLATE_MAP 一一对应）
	accountTemplate: {
		"SME_NPV_SMALL": "小企业会计准则·小规模纳税人",
		"SME_NPV_GENERAL": "小企业会计准则·一般纳税人",
		"ENT_NPV_SMALL": "企业会计准则·小规模纳税人",
		"ENT_NPV_GENERAL": "企业会计准则·一般纳税人",
		"NP2004_SMALL": "民间非营利组织会计制度(2004)·小规模纳税人",
		"NP2004_GENERAL": "民间非营利组织会计制度(2004)·一般纳税人",
		"NP2026_SMALL": "民间非营利组织会计制度(2026)·小规模纳税人",
		"NP2026_GENERAL": "民间非营利组织会计制度(2026)·一般纳税人",
		"UNION2010_GENERAL": "工会会计制度(2010)·一般纳税人",
		"ENT2019_OLD_SMALL": "企业会计准则(2019未执行新准则)·小规模纳税人",
		"ENT2019_OLD_GENERAL": "企业会计准则(2019未执行新准则)·一般纳税人",
		"ENT2019_NEW_SMALL": "企业会计准则(2019已执行新准则)·小规模纳税人",
		"ENT2019_NEW_GENERAL": "企业会计准则(2019已执行新准则)·一般纳税人"
	},
	// 凭证现金流平衡检查：0.不检查 1.检查并提醒 2.检查并限制保存
	cashFlowBalanceCheck: {0: "不检查", 1: "检查并提醒", 2: "检查并限制保存"}
});
